import { Manufacturer } from 'models/Manufacturer';
import { Unit } from 'models/Unit';

export class MachineType {
    id: number;
    name: string;
    manufacturer: Manufacturer;
    serviceLifeUnit?: Unit | null;
    archivedDate?: Date;
    
    constructor (
        id:number,
        name: string,
        manufacturer: Manufacturer,
        serviceLifeUnit?: Unit | null,
        archivedDate?: Date
    ) {
        this.id = id;
        this.name = name;
        this.manufacturer = manufacturer;
        this.serviceLifeUnit = serviceLifeUnit;
        this.archivedDate = archivedDate;
    }

    static empty(): MachineType {
        return { id: 0, name: '', manufacturer: Manufacturer.empty(), serviceLifeUnit: Unit.empty()};
    }

}